export const TRIGGER_EVENT_LABELS = {
  UserRegistered: "ثبت‌نام کاربر",
  ProfileCompleted: "تکمیل پروفایل",
  ConsultationCreated: "ثبت درخواست مشاوره",
  ProjectRequestCreated: "ثبت درخواست نیروگاه",
  DocumentsCompleted: "تکمیل مدارک",
  LoanApproved: "تأیید وام",
  ContractSigned: "امضای قرارداد",
  PaymentReceived: "دریافت پرداخت",
  ProjectInstalled: "نصب نیروگاه",
  ProjectSettled: "تسویه نهایی پروژه",
};

export const CALCULATION_TYPE_LABELS = {
  FixedAmount: "مبلغ ثابت",
  Percentage: "درصدی",
  TieredFixedAmount: "مبلغ ثابت پلکانی",
  TieredPercentage: "درصدی پلکانی",
  ManualApproval: "تأیید دستی",
};

export const PERCENT_BASE_LABELS = {
  OrderAmount: "مبلغ سفارش",
  PaidAmount: "مبلغ پرداخت‌شده",
  SolarentNetProfit: "سود خالص سولارنت",
  CommissionBaseAmount: "مبلغ مبنای پورسانت",
  ParentCommissionAmount: "پورسانت والد",
};

export const PAYMENT_STATUS_LABELS = {
  Pending: "در انتظار",
  Processing: "در حال پردازش",
  Success: "موفق",
  Failed: "ناموفق",
  Cancelled: "لغو شده",
  Refunded: "بازگشت وجه",
};

export const LOAN_STATUS_LABELS = {
  Pending: "در انتظار",
  Approved: "تأیید شده",
  Rejected: "رد شده",
  Settled: "تسویه شده",
};

export const toSelectOptions = (labels) =>
  Object.entries(labels).map(([value, label]) => ({ value, label }));

export const getEnumLabel = (labels, value) => {
  if (value == null || value === "") return "—";
  if (labels[value]) return labels[value];
  const key = Object.keys(labels).find(
    (k) => k.toLowerCase() === String(value).toLowerCase()
  );
  return key ? labels[key] : String(value);
};

export const isTieredCalculation = (calculationType) =>
  calculationType === "TieredFixedAmount" || calculationType === "TieredPercentage";

export const isPercentageCalculation = (calculationType) =>
  calculationType === "Percentage" || calculationType === "TieredPercentage";
